import { getPublicFile } from "./getPublicFile";
import { versionInfoSchema, type VersionInfo } from "./versionSchema";

export async function getVersion(): Promise<VersionInfo> {
  try {
    const versionContent = await getPublicFile({
      data: {
        filePath: "version.json",
      },
    });
    const versionData = versionInfoSchema.parse(JSON.parse(versionContent));
    return versionData;
  } catch {
    // Version fetch failed, fallback to env vars
  }

  const currentVersion = import.meta.env.VITE_APP_VERSION ?? "dev";

  return {
    version: currentVersion,
    fullVersion: import.meta.env.VITE_APP_FULL_VERSION ?? currentVersion,
    deployedAt: import.meta.env.VITE_APP_DEPLOYED_AT ?? null,
  };
}
